var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { convertObjectType } from '@hb/map-convert';
import { ServiceTypeEnum } from '../../enums';
import { aMapRequest } from '../../request/amap';
import { fetchWrap } from '../../request/fetch';
import { getCacheOptions } from '../../utils';
import { isObject } from '../../utils/is';
import pick from '../../utils/lodash/pick';
import { removeEmpty, V4TransformAMapBasicResponse, } from '../../utils/transform';
import { dataType, queryType } from './convert';
/**
 * 骑行路径规划
 * @description https://lbs.amap.com/api/webservice/guide/api/direction#t7
 */
export function getV4DirectionBicycling(_a) {
    var key = _a.key, query = _a.query;
    return aMapRequest({
        key: key,
        url: '/v4/direction/bicycling',
        params: __assign({}, query),
    });
}
function transformParams(params) {
    var key = params.key, query = params.query;
    var pickKeys = ['origin', 'destination']; // TS3.4 syntax
    var queryPick = pick(query, pickKeys);
    var convertResult = convertObjectType(queryPick, queryType);
    return {
        key: key,
        query: removeEmpty(convertResult),
    };
}
function transformResponse(response) {
    var data = response.data;
    if (isObject(data)) {
        var result = convertObjectType(data, dataType);
        var origin_1 = data.origin, destination = data.destination;
        return V4TransformAMapBasicResponse(response, __assign(__assign({}, result), { origin: origin_1, destination: destination }));
    }
    return V4TransformAMapBasicResponse(response);
}
/**
 * 骑行路径规划
 * @description https://lbs.amap.com/api/webservice/guide/api/direction#t7
 */
function bikeRouteByServer(query, options) {
    var key = options.key, context = options.context, cache = options.cache, serveSort = options.serveSort, method = options.method;
    return fetchWrap(getV4DirectionBicycling, {
        context: context,
        serveSort: serveSort,
        method: method,
        cache: getCacheOptions(cache),
        mapOptions: options,
        params: { key: key, query: query },
        serviceType: ServiceTypeEnum.GAODE,
        transformParams: transformParams,
        transformResponse: transformResponse,
    });
}
export default bikeRouteByServer;
//# sourceMappingURL=data:application/json;base64,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